import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaUserMd,
  FaUserInjured,
  FaFlask,
  FaTools,
  FaShoppingCart,
  FaChartBar,
  FaMoneyBillWave,
  FaPhoneAlt,
  FaChevronDown,
  FaChevronRight,
} from "react-icons/fa";
import { MdDashboard, MdOutlineSmartToy } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { IoLibrarySharp } from "react-icons/io5";
import { MdLocalPharmacy } from "react-icons/md";
import { GiExpense } from "react-icons/gi";
import { IoMdSettings } from "react-icons/io";
// import { MdOutlineSignalCellularAlt1Bar } from "react-icons/md";
import axios from "axios";
import Apiurl from "./../environment/Apiurl";
import {
  reconcileRolePages,
  ROLE_PAGE_ITEMS,
} from "../../utils/rolePagesMigration";
import "./Sidebar.css";

// Mapping to align UI menu names with backend page names
const pageNameMapping = {
  "Patient List": "Patients",
  "Patient Birthday": "Patients",
};

const Sidebar = ({
  collapsed,
  toggleSidebar,
  isOpen,
  closeSidebar,
  isMobile,
}) => {
  const location = useLocation();
  const [openDropdowns, setOpenDropdowns] = useState({
    hr: false,
    pharmacy: false,
    fee: false,
    billing: false,
    patient: false,
    followUp: false,
  });
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredTooltip, setHoveredTooltip] = useState(null);
  const [hasNavigatedToDashboard, setHasNavigatedToDashboard] = useState(false);
  const [hasNavigatedToBilling, setHasNavigatedToBilling] = useState(false);
  const [hasNavigatedToPatients, setHasNavigatedToPatients] = useState(false);
  const [hasNavigatedToRoles, setHasNavigatedToRoles] = useState(false);
  const [hasNavigatedToStaff, setHasNavigatedToStaff] = useState(false);
  // IN BILLING TEMPORARILY DISABLED
  // const [hasNavigatedToInBilling, setHasNavigatedToInBilling] = useState(false);
  const [hasNavigatedToOutBilling, setHasNavigatedToOutBilling] =
    useState(false);
  const [hasNavigatedToPurchaseOrder, setHasNavigatedToPurchaseOrder] =
    useState(false);
  const [hasNavigatedToPurchasePharmacy, setHasNavigatedToPurchasePharmacy] =
    useState(false);
  const [hasNavigatedToSalePharmacy, setHasNavigatedToSalePharmacy] =
    useState(false);
  const [rolesData, setRolesData] = useState([]);
  const [userPrivileges, setUserPrivileges] = useState({});

  const menuItemRefs = useRef({});

  const fetchRolesData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/roles_and_privillage`);
      console.log("Sidebar roles data:", response.data);
      setRolesData(response.data || []);

      const userRoleID = localStorage.getItem("role_id") || "unknown";

      const userRoleData = response.data.find(
        (role) => role.role_id === userRoleID
      );

      if (userRoleData) {
        const privileges = {};
        const reconciledPages = reconcileRolePages(
          userRoleData.pages,
          ROLE_PAGE_ITEMS
        );
        reconciledPages.forEach((page) => {
          privileges[page.page] = {
            access: page.access,
            ...page.priviallages,
          };
        });
        setUserPrivileges(privileges);
      } else {
        console.warn("User role not found in roles data");
      }
    } catch (error) {
      console.error("Error fetching roles:", error.message);
    }
  };

  useEffect(() => {
    fetchRolesData();
  }, []);

  useEffect(() => {
    // Auto-expand sidebar on navigation for desktop (from first version)
    if (
      location.pathname === "/dashboard" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToDashboard
    ) {
      toggleSidebar();
      setHasNavigatedToDashboard(true);
    }
    if (
      location.pathname === "/billing" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToBilling
    ) {
      toggleSidebar();
      setHasNavigatedToBilling(true);
    }
    // IN BILLING TEMPORARILY DISABLED
    // if (
    //   location.pathname === "/billing/in-billing" &&
    //   !isMobile &&
    //   collapsed &&
    //   !hasNavigatedToInBilling
    // ) {
    //   toggleSidebar();
    //   setHasNavigatedToInBilling(true);
    // }
    if (
      location.pathname === "/billing/out-billing" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToOutBilling
    ) {
      toggleSidebar();
      setHasNavigatedToOutBilling(true);
    }
    if (
      location.pathname === "/patients" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToPatients
    ) {
      toggleSidebar();
      setHasNavigatedToPatients(true);
    }
    if (
      location.pathname === "/hr-management/staff" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToStaff
    ) {
      toggleSidebar();
      setHasNavigatedToStaff(true);
    }
    if (
      location.pathname === "/pharmacy/purchase-order" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToPurchaseOrder
    ) {
      toggleSidebar();
      setHasNavigatedToPurchaseOrder(true);
    }
    if (
      location.pathname === "/pharmacy/purchase-pharmacy" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToPurchasePharmacy
    ) {
      toggleSidebar();
      setHasNavigatedToPurchasePharmacy(true);
    }
    if (
      location.pathname === "/pharmacy/sale-pharmacy" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToSalePharmacy
    ) {
      toggleSidebar();
      setHasNavigatedToSalePharmacy(true);
    }
    if (
      location.pathname === "/roles" &&
      !isMobile &&
      collapsed &&
      !hasNavigatedToRoles
    ) {
      toggleSidebar();
      setHasNavigatedToRoles(true);
    }

    // Reset navigation flags when leaving pages
    if (location.pathname !== "/dashboard") {
      setHasNavigatedToDashboard(false);
    }
    if (location.pathname !== "/billing") {
      setHasNavigatedToBilling(false);
    }
    if (location.pathname !== "/patients") {
      setHasNavigatedToPatients(false);
    }
    if (location.pathname !== "/roles") {
      setHasNavigatedToRoles(false);
    }
    if (location.pathname !== "/hr-management/staff") {
      setHasNavigatedToStaff(false);
    }
    // IN BILLING TEMPORARILY DISABLED
    // if (location.pathname !== "/billing/in-billing") {
    //   setHasNavigatedToInBilling(false);
    // }
    if (location.pathname !== "/billing/out-billing") {
      setHasNavigatedToOutBilling(false);
    }
    if (location.pathname !== "/pharmacy/purchase-order") {
      setHasNavigatedToPurchaseOrder(false);
    }
    if (location.pathname !== "/pharmacy/purchase-pharmacy") {
      setHasNavigatedToPurchasePharmacy(false);
    }
    if (location.pathname !== "/pharmacy/sale-pharmacy") {
      setHasNavigatedToSalePharmacy(false);
    }
  }, [
    location.pathname,
    isMobile,
    collapsed,
    toggleSidebar,
    hasNavigatedToDashboard,
    hasNavigatedToBilling,
    hasNavigatedToPatients,
    hasNavigatedToRoles,
    hasNavigatedToStaff,
    // hasNavigatedToInBilling, // IN BILLING TEMPORARILY DISABLED
    hasNavigatedToOutBilling,
    hasNavigatedToPurchaseOrder,
    hasNavigatedToPurchasePharmacy,
    hasNavigatedToSalePharmacy,
  ]);

  useEffect(() => {
    const currentPath = location.pathname;
    const dropdownPaths = [
      "/hr-management",
      "/pharmacy",
      "/fees-management",
      "/billing",
      "/patients",
      "/follow-up-calls",
    ];
    const isDropdownPath = dropdownPaths.some((path) =>
      currentPath.startsWith(path)
    );
    // Only reset dropdowns if not on a dropdown path and not triggered by logo click
    if (!isDropdownPath && !openDropdowns.logoClicked) {
      setOpenDropdowns({
        hr: false,
        pharmacy: false,
        fee: false,
        billing: false,
        logoClicked: false,
        patient: false,
        followUp: false,
      });
    }
  }, [location.pathname]);

  const toggleDropdown = (dropdownName) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [dropdownName]: !prev[dropdownName],
      logoClicked: false,
    }));
  };

  const handleSubItemClick = (parentDropdown) => {
    setOpenDropdowns({
      hr: parentDropdown === "hr",
      pharmacy: parentDropdown === "pharmacy",
      fee: parentDropdown === "fee",
      billing: parentDropdown === "billing",
      patient: parentDropdown === "patient",
      followUp: parentDropdown === "followUp",
      logoClicked: false,
    });
  };

  const handleMouseEnter = (itemIndex, event) => {
    if (!isMobile && collapsed) {
      const rect = event.currentTarget.getBoundingClientRect();
      setHoveredItem({
        index: itemIndex,
        top: rect.top,
        left: rect.right + 10,
      });
    }
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const handleTooltipMouseEnter = (itemIndex, itemName, event) => {
    if (!isMobile && collapsed) {
      const rect = event.currentTarget.getBoundingClientRect();
      setHoveredTooltip({
        index: itemIndex,
        name: itemName,
        top: rect.top + rect.height / 2 - 20,
        left: rect.right + 10,
      });
    }
  };

  const handleTooltipMouseLeave = () => {
    setHoveredTooltip(null);
  };

  const menuItems = [
    { name: "Dashboard", icon: <MdDashboard />, path: "/dashboard" },
    { name: "Roles", icon: <IoMdSettings />, path: "/roles" },
    { name: "Users", icon: <FaRegUser />, path: "/users" },
    {
      name: "HR Management",
      icon: <MdManageAccounts />,
      path: "/hr-management",
      dropdown: "hr",
      subItems: [
        { name: "Staff", path: "/hr-management/staff" },
        { name: "Department", path: "/hr-management/department" },
        { name: "Attendance", path: "/hr-management/attendance" },
        { name: "Shift", path: "/hr-management/shift" },
        { name: "Leave Management", path: "/hr-management/leave" },
        { name: "Salary Details", path: "/hr-management/salary-details" },
        { name: "Holiday", path: "/hr-management/holiday" },
      ],
    },
    { name: "Doctors", icon: <FaUserMd />, path: "/doctors" },
    {
      name: "Fees Management",
      icon: <FaMoneyBillWave />,
      path: "/fees-management",
      dropdown: "fee",
      subItems: [
        {
          name: "Treatment Charges",
          path: "/fees-management/treatment_charges",
        },
        {
          name: "Doctor Fee Master",
          path: "/fees-management/doctorfee_master",
        },
      ],
    },
    {
      name: "Patients",
      icon: <FaUserInjured />,
      path: "/patients",
      dropdown: "patient",
      subItems: [
        {
          name: "Patient List",
          path: "/patients",
        },
        // {
        //   name: "Yoga Patients",
        //   path: "/patients/yoga-patients",
        // },
        // {
        //   name: "Homeopathy Patients",
        //   path: "/patients/homeopathy-patients",
        // },
        {
          name: "Patient Birthday",
          path: "/patients/patient-birthday",
        },
      ],
    },
    { name: "Appointments", icon: <IoLibrarySharp />, path: "/appointments" },
    {
      name: "Follow-up Call",
      icon: <FaPhoneAlt />,
      path: "/follow-up-calls",
      dropdown: "followUp",
      subItems: [
        { name: "Courtesy Call", path: "/follow-up-calls/courtesy-call" },
        { name: "Follow-up 1", path: "/follow-up-calls/follow-up-1" },
        { name: "Follow-up 2", path: "/follow-up-calls/follow-up-2" },
      ],
    },
    {
      name: "Billing",
      icon: <MdManageAccounts />,
      path: "/billing",
      dropdown: "billing",
      subItems: [
        // { name: "IN Billing", path: "/billing/in-billing" }, // TEMPORARILY DISABLED
        { name: "OUT Billing", path: "/billing/out-billing" },
      ],
    },
    {
      name: "Pharmacy",
      icon: <MdLocalPharmacy />,
      path: "/pharmacy",
      dropdown: "pharmacy",
      subItems: [
        { name: "Medicine List", path: "/pharmacy/medicine-master" },
        { name: "Prescription", path: "/pharmacy/prescription" },
        { name: "Purchase Order", path: "/pharmacy/purchase-order" },
        { name: "Purchase List", path: "/pharmacy/purchase-pharmacy" },
        { name: "Sale Pharmacy", path: "/pharmacy/sale-pharmacy" },
        { name: "Stock Management", path: "/pharmacy/stock-management" },
        { name: "Supplier", path: "/pharmacy/supplier" },
        { name: "Reports Pharmacy", path: "/pharmacy/reports" },
      ],
    },
    { name: "Lab Management", icon: <FaFlask />, path: "/lab-management" },
    { name: "Expenses", icon: <GiExpense />, path: "/expenses" },
    {
      name: "Hospital Maintenance",
      icon: <FaTools />,
      path: "/hospital-maintenance",
    },
    {
      name: "Hospital Purchases",
      icon: <FaShoppingCart />,
      path: "/hospital-purchases",
    },
    { name: "Chat", icon: <MdOutlineSmartToy />, path: "/chat" },
    { name: "Reports", icon: <FaChartBar />, path: "/reports" },
  ];

  const itemHasSubItems = (path) => {
    const found = menuItems.find((item) => item.path === path);
    return found?.subItems?.length > 0;
  };

  const handleItemClick = (itemPath) => {
    setOpenDropdowns({
      hr: false,
      pharmacy: false,
      fee: false,
      billing: false,
      patient: false,
      followUp: false,
      logoClicked: false,
    });
    if (isMobile && !itemHasSubItems(itemPath)) {
      closeSidebar();
    } else if (!isMobile && collapsed) {
      toggleSidebar();
    }
  };

  const handleDropdownClick = (dropdownName) => {
    // Prevent dropdown toggle when collapsed (from first version)
    if (!collapsed) {
      toggleDropdown(dropdownName);
    }
  };

  const handleSubmenuItemClick = (subItemPath, parentDropdown) => {
    handleSubItemClick(parentDropdown);
    if (isMobile) {
      closeSidebar();
    } else {
      // Smart sidebar behavior for specific routes (from first version)
      if (
        subItemPath === "/pharmacy/purchase-pharmacy/add-purchase-pharmacy" ||
        subItemPath === "/pharmacy/sale-pharmacy/add-sale-pharmacy"
      ) {
        if (!collapsed) toggleSidebar();
      } else {
        if (collapsed) toggleSidebar();
      }
    }
  };

  // Enhanced filter logic for menu items and subitems
  const filteredMenuItems = menuItems
    .filter((item) => {
      if (!item.subItems) {
        const pageName = pageNameMapping[item.name] || item.name;
        if (item.name === "Chat" && localStorage.getItem("role_name") === "Super Admin") {
          return true;
        }
        return userPrivileges[pageName]?.access === true;
      } else {
        if (
          item.name === "Follow-up Call" &&
          localStorage.getItem("role_name") === "Super Admin"
        ) {
          return true;
        }
        const hasAccessToSubItem = item.subItems.some(
          (subItem) =>
            userPrivileges[pageNameMapping[subItem.name] || subItem.name]
              ?.access === true
        );
        return hasAccessToSubItem;
      }
    })
    .map((item) => ({
      ...item,
      subItems: item.subItems
        ? item.subItems.filter((subItem) => {
            if (
              item.name === "Follow-up Call" &&
              localStorage.getItem("role_name") === "Super Admin"
            ) {
              return true;
            }
            return (
              userPrivileges[pageNameMapping[subItem.name] || subItem.name]
                ?.access === true
            );
          })
        : undefined,
    }));

  // Handle logo click to toggle sidebar and reset dropdowns
  const handleLogoClick = () => {
    if (!isMobile) {
      toggleSidebar();
      setOpenDropdowns({
        hr: false,
        pharmacy: false,
        fee: false,
        billing: false,
        patient: false,
        followUp: false,
        logoClicked: true, // Flag to indicate logo was clicked
      });
    }
  };

  return (
    <>
      <div
        className={`sidebar-container
          ${!isMobile && collapsed ? "collapsed" : ""}
          ${isOpen ? "open" : ""}`}
      >
        <div className="sidebar-header">
          <div className="logo-container" onClick={handleLogoClick}>
            {!isMobile && collapsed ? (
              <img
                alt="Logo"
                className="logo-collapsed"
                src={require("../../assets/images/logo avatar.png")}
              />
            ) : (
              <div className="logo-with-text">
                <img
                  alt="Logo"
                  className="logo-full"
                  src={require("../../assets/images/Logo.png")}
                />
              </div>
            )}
          </div>
        </div>
        <div className="sidebar-section">
          <ul className="sidebar-menu">
            {filteredMenuItems.map((item, index) => (
              <React.Fragment key={index}>
                <li
                  ref={(el) => (menuItemRefs.current[index] = el)}
                  className={`sidebar-menu-item ${
                    location.pathname === item.path ||
                    (item.subItems &&
                      item.subItems.some((subItem) =>
                        location.pathname.startsWith(subItem.path)
                      ))
                      ? "active"
                      : ""
                  } ${
                    item.subItems && !isMobile && collapsed ? "has-submenu" : ""
                  }`}
                  onMouseEnter={(e) => {
                    if (item.subItems) {
                      handleMouseEnter(index, e);
                    } else {
                      handleTooltipMouseEnter(index, item.name, e);
                    }
                  }}
                  onMouseLeave={() => {
                    if (item.subItems) {
                      handleMouseLeave();
                    } else {
                      handleTooltipMouseLeave();
                    }
                  }}
                >
                  {item.subItems ? (
                    <div
                      className="menu-link"
                      onClick={() => handleDropdownClick(item.dropdown)}
                    >
                      <span className="menu-icon">{item.icon}</span>
                      {(!isMobile || !collapsed) && (
                        <>
                          <span className="menu-text">{item.name}</span>
                          <span className="dropdown-arrow">
                            {openDropdowns[item.dropdown] ? (
                              <FaChevronDown />
                            ) : (
                              <FaChevronRight />
                            )}
                          </span>
                        </>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.path}
                      className="menu-link"
                      onClick={() => handleItemClick(item.path)}
                    >
                      <span className="menu-icon">{item.icon}</span>
                      {(!isMobile || !collapsed) && (
                        <span className="menu-text">{item.name}</span>
                      )}
                    </Link>
                  )}
                </li>

                {item.subItems &&
                  !isMobile &&
                  collapsed &&
                  hoveredItem &&
                  hoveredItem.index === index && (
                    <div
                      className="hover-submenu"
                      style={{
                        position: "fixed",
                        top: hoveredItem.top,
                        left: "70px",
                        zIndex: 1002,
                      }}
                      onMouseEnter={() => setHoveredItem(hoveredItem)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div className="hover-submenu-header">
                        <span className="menu-icon">{item.icon}</span>
                        <span className="menu-text">{item.name}</span>
                      </div>
                      <ul className="hover-submenu-list">
                        {item.subItems.map((subItem, subIndex) => (
                          <li key={subIndex} className="hover-submenu-item">
                            <Link
                              to={subItem.path}
                              className="hover-submenu-link"
                              onClick={() =>
                                handleSubmenuItemClick(
                                  subItem.path,
                                  item.dropdown
                                )
                              }
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span>{subItem.name}</span>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                {!item.subItems &&
                  !isMobile &&
                  collapsed &&
                  hoveredTooltip &&
                  hoveredTooltip.index === index && (
                    <div
                      className="menu-tooltip"
                      style={{
                        position: "fixed",
                        top: hoveredTooltip.top,
                        left: "70px",
                        zIndex: 1002,
                      }}
                    >
                      <div className="tooltip-content">
                        <span className="tooltip-text">
                          {hoveredTooltip.name}
                        </span>
                      </div>
                    </div>
                  )}

                {item.subItems &&
                  openDropdowns[item.dropdown] &&
                  !collapsed && (
                    <ul className="submenu mt-2">
                      {item.subItems.map((subItem, subIndex) => (
                        <li
                          key={subIndex}
                          className={`submenu-item ${
                            location.pathname === subItem.path
                              ? "active"
                              : ""
                          }`}
                        >
                          <Link
                            to={subItem.path}
                            className="submenu-link"
                            onClick={() =>
                              handleSubmenuItemClick(
                                subItem.path,
                                item.dropdown
                              )
                            }
                          >
                            <div className="d-flex align-items-center gap-2">
                              <span className="mt-1">{subItem.name}</span>
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
      {isMobile && isOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar} />
      )}
    </>
  );
};

export default Sidebar;